import {Suspense} from 'react'
import TopBarProgress from 'react-topbar-progress-indicator'
import {BasicComponentProps} from '../types'
import LoadingIndicator from './LoadingIndicator'

function SuspensedView({children}: BasicComponentProps) {
  TopBarProgress.config({
    barColors: {
      '0': '#2ad590',
    },
    barThickness: 3,
    shadowBlur: 5,
  })

  return <Suspense fallback={<LoadingIndicator />}>{children}</Suspense>
}

export default SuspensedView
